// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2XqGA","buttons":"Footer_buttons__1341W"};